<section class="body-sign">
    <div class="center-sign">
        <a href="/" class="logo w-100 text-center d-block">
            <img src="assets/img/logo.png" height="44" alt="Comply365" />
        </a>

        <div class="panel card-sign">

            <h3 class="title text-center text-uppercase font-weight-light my-4">Sign In</h3>

            <div class="card-body">
                <form #loginForm="ngForm" (submit)="attemptLogin()">
                    <error-message [errors]="errors"></error-message>
                    <div class="form-group mb-3">
                        <label>Username</label>
                        <div class="input-group">
                            <input name="username" type="text" class="form-control form-control-lg" [(ngModel)]="username" required />
                            <span class="input-group-append">
                                <span class="input-group-text">
                                    <i class="fas fa-user"></i>
                                </span>
                            </span>
                        </div>
                    </div>

                    <div class="form-group mb-3">
                        <div class="clearfix">
                            <label class="float-left">Password</label>
                            <a [routerLink]="['/auth/recover-password']" class="float-right">Lost Password?</a>
                        </div>
                        <div class="input-group">
                            <input name="pwd" type="password" class="form-control form-control-lg" [(ngModel)]="password" tabindex="2" required />
                            <span class="input-group-append">
                                <span class="input-group-text">
                                    <i class="fas fa-lock"></i>
                                </span>
                            </span>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-8">
                            <div class="checkbox-custom checkbox-default">
                                <input id="RememberMe" name="rememberme" type="checkbox" />
                                <label for="RememberMe">Remember Me</label>
                            </div>
                        </div>
                        <div class="col-sm-4 text-right">
                            <button type="submit" class="btn btn-primary mt-2">Sign In</button>
                        </div>
                    </div>

                    <p class="text-center mt-3 text-info">Don't have an account yet? <a href="https://www.saleskey.com.au/" target="_blank">Call SalesKey to talk to us today</a></p>

                </form>
            </div>
        </div>

        <p class="text-center text-muted mt-3 mb-3">&copy; Copyright 2020. All Rights Reserved.</p>
    </div>
</section>
